<div [formGroup]="attachmentForm">
    <p-panel [header]="headerText" styleClass="mb-5 {{headerStyleClass}}">
      <div *ngIf="headerHidden" class="custom-panel-header">Attachments</div>
       <app-loader></app-loader>

    <!-- <div class="row mb-3">
      <label class="form-label d-block"> -->
        <!-- <p>
          Supported file formats are
          <span class="semi-bold-text">pdf, excel (xls or xlsx), csv, doc and docx and images</span>.
          The maximum file size allowed is <span class="semi-bold-text"></span>
        </p> -->
        <p>
          <span class="semi-bold-text">{{instructionText}}</span>
        <br />
        <span class="text-muted">{{instructionText2}}</span>
        </p>
        
      <!-- </label>
    </div> -->

     <div class="row" aria-label="Upload attachment fields">
      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label class="form-label d-block" for="fileUpload">Document</label>
        <p-fileupload
          #fileUpload
          *ngIf="fileUploadVisible"
          id="fileUpload"
          mode="basic"
          chooseLabel="Choose File"
          chooseIcon="pi pi-upload"
          name="recordFile[]"
          url=""
          maxFileSize="52428800"
          invalidFileSizeMessageSummary=""
          (onSelect)="onFileSelect($event, fileUpload)"
        ></p-fileupload>
        <small *ngIf="fileSizeError" class="error-label">
          Invalid file size, maximum upload size is 100MB.
        </small>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label
          class="form-label d-block"
          [ngClass]="{ 'required-asterisk': isFileUploaded() }"
          for="attachmentLabel"
          >Label</label
        >
        <p-select
          id="attachmentLabel"
          formControlName="orderInfoAttachmentLabel"
          [options]="attachmentLabels"
          optionLabel="name"
          placeholder="Select label"
          styleClass="w-100"
          (onChange)="onLabelChange($event)"
          appendTo="body"
          [ngClass]="{ 'ng-invalid ng-dirty': isError('orderInfoAttachmentLabel') }"
        ></p-select>
        <small *ngIf="isError('orderInfoAttachmentLabel')" class="error-label">
          This field is mandatory
        </small>
      </div>

      <div
        class="col-sm-12 col-md-6 col-lg-3 mb-3"
        *ngIf="showDescription"
      >
        <label
          class="form-label d-block required-asterisk"
          for="attachmentDescription"
          >Description</label
        >
        <input
          pInputText
          id="attachmentDescription"
          type="text"
          placeholder="Enter description"
          class="form-control"
          formControlName="orderInfoAttachmentExplanation"
          [ngClass]="{ 'ng-invalid ng-dirty': isError('orderInfoAttachmentExplanation') }"
          (input)="onDescriptionChange()"
        />
        <small
          *ngIf="isError('orderInfoAttachmentExplanation')"
          class="error-label"
        >
          This field is mandatory
        </small>
      </div>
      <!-- [ngClass]="{ 'mt-4': showDescription && isBetween576And992 }" -->
      <div class="col-sm-12 col-md-6 col-lg-3 mt-0 mt-lg-4 mb-3 button-container" [ngClass]="{ 'mt-sm-4': showDescription && isBetween576And992 }">
        <p-button label="Upload" [disabled]="isUploadDisabled" (onClick)="uploadFile($event)" tabindex="0"></p-button>
        <p-button label="Cancel" severity="secondary" (onClick)="cancelUpload(fileUpload)" styleClass="ms-3"></p-button>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-12 col-md-12 col-lg-9">
        <span class="sr-only">Uploaded Attachments</span>
        <p-table [value]="attachments" [rows]="5" styleClass="table-light-header">
          <ng-template pTemplate="header">
            <tr>
              <th class="width:30%">Label</th>
              <th class="width:50%">Uploaded Files</th>
              <th class="width: 20%">Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-attachment>
            <tr>
              <td data-label="Label" class="width:30%">{{ getLabelDescription(attachment.description) }}</td>
              <td data-label="Uploaded Files" class="width:50%">
                <p-button styleClass="px-0" [label]="attachment.filename" (onClick)="downloadFile(attachment.fileId)"
                  [link]="true"></p-button>
              </td>
              <td data-label="Actions">
                <p-button styleClass="px-0" icon="pi pi-trash" label="Delete"
                  [disabled]="editOrder && attachment.deleteDisabled" [text]="true"
                  (onClick)="showFileDeletionModal(attachment.fileId)"></p-button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3" class="p-3 empty-message">No files uploaded!</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>
<app-modal [header]="'Delete Confirmation'" [(showDialog)]="showFileDeleteModal" [rejectLabel]="'No'"
  [acceptLabel]="'Yes'" (acceptModalClick)="  confirmFileDeletion()" (rejectModalClick)="showFileDeleteModal = false">
  <span>Are you sure want to delete this file?</span>
</app-modal>